<google-map [options]="options"
            (mapInitialized)="onMapReady($event)"
            (mapDrag)="clearTracking()"
            (maptypeidChanged)="mapTypeChanged()"
            (zoomChanged)="clearTracking()">
  <map-marker #marker
              *ngFor="let camera of markers"
              [position]="camera.position"
              [title]="camera.title"
              [label]="camera.label"
              (mapClick)="openMeta(marker, camera)"
              (mouseOver)="highlightMarker(camera)"
              (mouseOut)="unHighlightMarker(camera)"
              [icon]="camera.icon"
              [options]="camera.options">
  </map-marker>
  <map-marker *ngIf="userLocation"
              [position]="userLocation"
              [icon]="userLocationMarker">
  </map-marker>
  <map-info-window></map-info-window>
</google-map>
